import React, { useEffect, useState } from "react";
import "./Survey.css";
import locked from "../../../images/locked.png";

function Survey({ clientData, password }) {
  const [deliveryMode, setDeliveryMode] = useState("knowAddress");
  const [deliveryDay, setDeliveryDay] = useState(null);
  const [deliveryHour, setDeliveryHour] = useState(null);
  const [secureData, setSecureData] = useState(null);
  const [error, setError] = useState(null);
  const [phone, setPhone] = useState("");
  const [yourPhone, setYourPhone] = useState("");
  const urlLink = process.env.REACT_APP_API_URL;

  const formatPhone = (digits) => {
    const cleaned = digits.replace(/\D/g, "").slice(0, 10); // faqat 10 ta raqam
    const part1 = cleaned.slice(0, 3);
    const part2 = cleaned.slice(3, 6);
    const part3 = cleaned.slice(6, 8);
    const part4 = cleaned.slice(8, 10);

    let formatted = "";
    if (part1) formatted += `(${part1}`;
    if (part1.length === 3) formatted += `) `;
    if (part2) formatted += part2;
    if (part2.length === 3) formatted += `-`;
    if (part3) formatted += part3;
    if (part3.length === 2) formatted += `-`;
    if (part4) formatted += part4;

    return formatted;
  };

  const handleChange = (e) => {
    const value = e.target.value;
    const digits = value.replace(/\D/g, "").replace(/^7/, ""); // remove +7 if user types it
    setPhone(formatPhone(digits));
  };

  const handleYourPhoneChange = (e) => {
    const value = e.target.value;
    const digits = value.replace(/\D/g, "").replace(/^7/, ""); // remove +7 if user types it
    setYourPhone(formatPhone(digits));
  };

  useEffect(() => {
    if (clientData && clientData.address_mentioned === false) {
      setDeliveryMode("writeAddress");
    }
  }, [clientData]);

  useEffect(() => {
    if (password) {
      fetch(`${urlLink}api/saved-data/${clientData.uuid}?password=${password}`)
        .then((res) => {
          if (!res.ok) {
            if (res.status === 403) {
              throw new Error("Пароль неверный");
            }
            throw new Error("Пароль неверный или ошибка сервера");
          }
          return res.json();
        })

        .then((data) => {
          setSecureData(data);
          setError(null);
        })
        .catch((err) => {
          setError(err.message);
          setSecureData(null);
        });
    }
  }, [password, clientData.uuid]);

  const isWrongPassword = password && error === "Пароль неверный";
  const dataToShow = secureData || clientData;
  const showBlurOverlay = !secureData && clientData?.is_anonymous;

  const day = ["завтра", "послезавтра", "в любое время"];
  const hour = ["12:00 - 16:00", "16:00 - 20:00", "20:00 - 01:00"];

  const handleSubmit = (e) => {
    e.preventDefault();

    const city = document.getElementById("city")?.value.trim();
    const street = document.getElementById("street")?.value.trim();
    const building = document.getElementById("house")?.value.trim();
    const corpus = document.getElementById("building")?.value.trim();
    const flat = document.getElementById("apartment")?.value.trim();
    const phone_number = document.getElementById("phone")?.value.trim();
    const message = document.getElementById("textarea")?.value.trim();
    const buyer_phone = document.getElementById("yourNumber")?.value.trim();
    const time = `${deliveryDay}, ${deliveryHour}`;

    if (deliveryMode === "writeAddress") {
      if (!city) return alert("Пожалуйста, введите город.");
      if (!street) return alert("Пожалуйста, введите улицу.");
      if (!building) return alert("Пожалуйста, введите номер дома.");
      if (!phone_number) return alert("Пожалуйста, введите номер телефона.");
      if (!deliveryDay) return alert("Пожалуйста, выберите день доставки.");
      if (!deliveryHour) return alert("Пожалуйста, выберите время доставки.");
      const onlyDigits = phone_number.replace(/\D/g, ""); // Faqat raqamlar
      if (onlyDigits.length !== 11) {
        return alert("Пожалуйста, введите полный номер телефона (10 цифр).");
      }
      const onlyDigitsBuy = buyer_phone.replace(/\D/g, ""); // Faqat raqamlar
      if (onlyDigitsBuy.length !== 11) {
        return alert("Пожалуйста, введите полный номер телефона (10 цифр).");
      }
    }

    // Formni dinamik yig'ish
    const payload = {
      city,
      street,
      building,
      corpus,
      flat,
      phone_number,
      message,
      time,
      uuid: clientData?.uuid || null,
      buyer_phone,
      is_address_typed: true,
    };

    console.log(payload);

    fetch(`${urlLink}api/approved-data/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    })
      .then(async (res) => {
        const data = await res.json();

        if (!res.ok) {
          throw new Error(data?.message || "Ошибка при отправке данных.");
        }
        console.log(data);

        alert("Ваша информация была сохранена. Спасибо!");

        if (deliveryMode === "writeAddress") {
          document.getElementById("city").value = "";
          document.getElementById("street").value = "";
          document.getElementById("house").value = "";
          document.getElementById("building").value = "";
          document.getElementById("apartment").value = "";
          document.getElementById("textarea").value = ""; // <-- xabar maydoni ham
          setDeliveryDay(null);
          setDeliveryHour(null);
          setYourPhone("");
          setPhone("");
        }
      })
      .catch((err) => {
        console.error("❌ Error:", err);
        alert(err.message || "Ошибка при отправке формы.");
      });
  };

  return (
    <div className="survey">
      <div className="container " style={{ position: "relative" }}>
        <div className="survey__container">
          <h3 className="survey__header">Ладно, перейдем к заказу</h3>
          <div className="survey__tab-switch">
            <button
              className={
                deliveryMode === "knowAddress"
                  ? "survey__active"
                  : "survey__deactive"
              }
              onClick={(e) => {
                e.preventDefault();
                setDeliveryMode("knowAddress");
              }}
              disabled={clientData?.address_mentioned === false}
            >
              Мы даже адрес знаем..
            </button>

            <button
              className={
                deliveryMode === "writeAddress"
                  ? "survey__active"
                  : "survey__deactive"
              }
              onClick={(e) => {
                e.preventDefault();
                setDeliveryMode("writeAddress");
              }}
            >
              ввести самому
            </button>
          </div>

          <form className="survey__form">
            {deliveryMode === "knowAddress" && (
              <div className="survey__wrapper survey__container-wrapper">
                {showBlurOverlay && (
                  <div className="survey__blur-overlay">
                    <div className="survey__blur-content">
                      <img
                        src={locked}
                        alt="locked "
                        className="survey__blur-image"
                      />
                      <p className="survey__blur-text">
                        {isWrongPassword
                          ? "Пароль неверный. Попробуйте снова."
                          : "У нас есть данные для доставки, но они анонимные"}
                      </p>
                    </div>
                  </div>
                )}

                <div className="survey__form-group">
                  <label className="survey__label" htmlFor="city">
                    город
                  </label>
                  <input
                    type="text"
                    id="city"
                    name="city"
                    className="survey__input"
                    value={dataToShow?.city || ""}
                    readOnly
                  />
                </div>

                <div className="survey__form-group">
                  <label className="survey__label" htmlFor="street">
                    улица
                  </label>
                  <input
                    type="text"
                    id="street"
                    name="street"
                    className="survey__input"
                    value={dataToShow?.street || ""}
                    readOnly
                  />
                </div>

                <div className="survey__row">
                  <div className="survey__form-group">
                    <label className="survey__label" htmlFor="house">
                      дом
                    </label>
                    <input
                      type="text"
                      id="house"
                      name="house"
                      className="survey__input"
                      value={dataToShow?.building || ""}
                      readOnly
                    />
                  </div>
                  <div className="survey__form-group">
                    <label className="survey__label" htmlFor="building">
                      корпус
                    </label>
                    <input
                      type="text"
                      id="building"
                      name="building"
                      className="survey__input"
                      value={dataToShow?.corpus || ""}
                      readOnly
                    />
                  </div>
                  <div className="survey__form-group">
                    <label className="survey__label" htmlFor="apartment">
                      квартира
                    </label>
                    <input
                      type="text"
                      id="apartment"
                      name="apartment"
                      className="survey__input"
                      value={dataToShow?.flat || ""}
                      readOnly
                    />
                  </div>
                </div>

                <div className="survey__form-group">
                  <label className="survey__label" htmlFor="phone">
                    номер телефона
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    className="survey__input"
                    value={dataToShow?.phone_number || ""}
                    readOnly
                  />
                </div>

                <div className="survey__day-options">
                  {day.map((opt) => {
                    const parsedTime = dataToShow?.time
                      ?.split(",")
                      .map((s) => s.trim());
                    const isSelected = parsedTime?.includes(opt);

                    return (
                      <button
                        key={opt}
                        className={`survey__day-btn ${
                          isSelected ? "active" : ""
                        }`}
                        disabled
                      >
                        {opt}
                      </button>
                    );
                  })}
                </div>

                <div className="survey__form-group">
                  <label className="survey__label" htmlFor="textarea">
                    что то написать нам
                  </label>
                  <textarea
                    id="textarea"
                    name="textarea"
                    className="survey__input"
                    value={dataToShow?.message || ""}
                    readOnly
                  />
                </div>

                <div className="survey__hour-options">
                  {hour.map((opt) => {
                    const parsedTime = dataToShow?.time
                      ?.split(",")
                      .map((s) => s.trim());
                    const isSelected = parsedTime?.includes(opt);

                    return (
                      <button
                        key={opt}
                        className={`survey__hour-btn ${
                          isSelected ? "active" : ""
                        }`}
                        disabled
                      >
                        {opt}
                      </button>
                    );
                  })}
                </div>
              </div>
            )}

            {deliveryMode === "writeAddress" && (
              <div className="survey__wrapper">
                {/* Город */}
                <div className="survey__form-group">
                  <label className="survey__label" htmlFor="city">
                    город
                  </label>
                  <input
                    type="text"
                    id="city"
                    name="city"
                    className="survey__input"
                  />
                </div>

                {/* Улица */}
                <div className="survey__form-group">
                  <label className="survey__label" htmlFor="street">
                    улица
                  </label>
                  <input
                    type="text"
                    id="street"
                    name="street"
                    className="survey__input"
                  />
                </div>

                {/* Дом, корпус, квартира */}
                <div className="survey__row">
                  <div className="survey__form-group">
                    <label className="survey__label" htmlFor="house">
                      дом
                    </label>
                    <input
                      type="text"
                      id="house"
                      name="house"
                      className="survey__input"
                    />
                  </div>
                  <div className="survey__form-group">
                    <label className="survey__label" htmlFor="building">
                      корпус
                    </label>
                    <input
                      type="text"
                      id="building"
                      name="building"
                      className="survey__input"
                    />
                  </div>
                  <div className="survey__form-group">
                    <label className="survey__label" htmlFor="apartment">
                      квартира
                    </label>
                    <input
                      type="text"
                      id="apartment"
                      name="apartment"
                      className="survey__input"
                    />
                  </div>
                </div>

                {/* Телефон */}
                <div className="survey__form-group">
                  <label className="survey__label" htmlFor="phone">
                    номер телефона
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    className="survey__input"
                    value={"+7 " + phone}
                    onChange={handleChange}
                  />
                </div>

                {/* Дата доставки */}
                <div className="survey__day-options">
                  {day.map((opt) => (
                    <button
                      key={opt}
                      className={`survey__day-btn ${
                        deliveryDay === opt ? "active" : ""
                      }`}
                      onClick={(e) => {
                        e.preventDefault();
                        setDeliveryDay(opt);
                      }}
                    >
                      {opt}
                    </button>
                  ))}
                </div>

                <div className="survey__form-group">
                  <label className="survey__label" htmlFor="textarea">
                    что то написать нам
                  </label>
                  <textarea
                    id="textarea"
                    name="textarea"
                    className="survey__input"
                  />
                </div>

                <div className="survey__hour-options">
                  {hour.map((opt) => (
                    <button
                      key={opt}
                      className={`survey__hour-btn ${
                        deliveryHour === opt ? "active" : ""
                      }`}
                      onClick={(e) => {
                        e.preventDefault();
                        setDeliveryHour(opt);
                      }}
                    >
                      {opt}
                    </button>
                  ))}
                </div>
                <p className="survey__subtext1">
                  Если вдруг, что- пойдет не так
                </p>

                <div className="survey__form-group">
                  <label className="survey__label" htmlFor="yourNumber">
                    твой номер телефона
                  </label>
                  <input
                    type="tel"
                    id="yourNumber"
                    name="yourNumber"
                    className="survey__input"
                    value={"+7 " + yourPhone}
                    onChange={handleYourPhoneChange}
                  />
                </div>
                <div className="survey__btn-wrapper">
                  <button
                    className="survey__submit-btn1"
                    onClick={handleSubmit}
                  >
                    сохранить
                  </button>
                </div>
              </div>
            )}
          </form>
        </div>
      </div>
    </div>
  );
}

export default Survey;
